module.exports = __webpack_public_path__ + "img/5J.1fcf8ef0.jpg";